import { useState, createContext, useContext, useEffect } from 'react';

const MaskingContext = createContext({
  isMasked: false,
  toggleMasking: () => {}
});

export const useMasking = () => useContext(MaskingContext);

export const MaskingProvider = ({ children }) => {
  // Initialize state from localStorage
  const [isMasked, setIsMasked] = useState(() => {
    try {
      const saved = localStorage.getItem('budgetrecon_privacy_masking');
      return saved ? JSON.parse(saved) : false;
    } catch (err) {
      console.warn('Failed to load masking preference from localStorage:', err);
      return false;
    }
  });

  // Save to localStorage whenever masking state changes
  useEffect(() => {
    try {
      localStorage.setItem('budgetrecon_privacy_masking', JSON.stringify(isMasked));
    } catch (err) {
      console.warn('Failed to save masking preference to localStorage:', err);
    }
  }, [isMasked]);

  const toggleMasking = () => {
    setIsMasked(prev => !prev);
  };

  return (
    <MaskingContext.Provider value={{ isMasked, toggleMasking }}>
      {children}
    </MaskingContext.Provider>
  );
};